import { create } from "zustand";

interface StorageLimitExceededState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useStorageLimitExceededStore = create<StorageLimitExceededState>(
  (set) => ({
    isOpen: false,
    open: () => { set({ isOpen: true }); },
    close: () => { set({ isOpen: false }); },
  }),
);
